"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _BrandOverlay = _interopRequireDefault(require("../BrandOverlay"));

var _BrandSelect = _interopRequireDefault(require("../BrandSelect"));

var _constants = require("../../constants");

var _Issue = _interopRequireDefault(require("./Issue"));

var _context = _interopRequireWildcard(require("./context"));

var _BrandButton = _interopRequireDefault(require("../BrandButton"));

var _Other = _interopRequireDefault(require("./Other"));

var _Request = _interopRequireDefault(require("./Request"));

var _Background = _interopRequireDefault(require("./components/Background"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var REPORT_META_FIELDS = ['isValid'];
var StyledDialogContent = (0, _styles.styled)(_material.DialogContent)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & {\n    padding-inline: 0;\n    padding-block: 1rem;\n    \n    .MuiSelect-select {\n      font-weight: 400;\n    }\n  }\n"])));

function Feedback(_ref) {
  var selectedForm = _ref.selectedForm,
      onSubmit = _ref.onSubmit,
      locale = _ref.locale,
      _ref$userEmail = _ref.userEmail,
      userEmail = _ref$userEmail === void 0 ? '' : _ref$userEmail;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext = (0, _react.useContext)(_context.FormContext),
      report = _useContext.report,
      setReport = _useContext.setReport;

  var _useContext2 = (0, _react.useContext)(_context.FormContext),
      isLoading = _useContext2.isLoading,
      setIsLoading = _useContext2.setIsLoading;

  var filterMetaFields = (0, _react.useCallback)(function (reportData) {
    return Object.keys(reportData).filter(function (k) {
      return !REPORT_META_FIELDS.includes(k);
    }).reduce(function (prev, key) {
      if (key === 'image') {
        return _objectSpread(_objectSpread({}, prev), {}, {
          image: reportData.image[0]
        }); // FB form will have at most 1 image file
      }

      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, reportData[key]));
    }, {});
  }, []);
  (0, _react.useEffect)(function () {
    return setReport({
      email: userEmail,
      type: selectedForm,
      environment: navigator.userAgent,
      page: window.location.pathname,
      language_id: locale === 'en' ? 1 : 3
    });
  }, [userEmail, selectedForm]);

  var submitHandler = function submitHandler() {
    setIsLoading(true);
    onSubmit(filterMetaFields(report), function (onCloseCallback) {
      setIsLoading(false);
      onCloseCallback();
    });
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, {
    feedback_report_bug: /*#__PURE__*/_react.default.createElement(_Issue.default, null),
    feedback_report_request: /*#__PURE__*/_react.default.createElement(_Request.default, null),
    feedback_report_other: /*#__PURE__*/_react.default.createElement(_Other.default, null)
  }[selectedForm], /*#__PURE__*/_react.default.createElement(_material.DialogActions, {
    sx: {
      p: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_BrandButton.default, {
    sx: {
      backgroundColor: 'error.main'
    },
    onClick: function onClick() {
      return submitHandler();
    },
    disabled: !report.isValid || isLoading,
    isRequesting: isLoading
  }, t('feedback_report_action_submit'))));
}

Feedback.propTypes = {
  selectedForm: _propTypes.default.string
};

function FeedbackForm(_ref2) {
  var _onClose = _ref2.onClose,
      onSubmit = _ref2.onSubmit,
      locale = _ref2.locale,
      service = _ref2.service,
      _ref2$userEmail = _ref2.userEmail,
      userEmail = _ref2$userEmail === void 0 ? '' : _ref2$userEmail;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      selectedForm = _useState2[0],
      setSelectedForm = _useState2[1];

  var formTypes = _constants.FEEDBACK_FORM_TYPES.map(function (formType) {
    return {
      label: t(formType),
      value: formType
    };
  });

  var submitHandler = function submitHandler(report, isLoadingCallback) {
    if (!onSubmit) throw new Error('FeedbackForm > Feedback: error invoking onSubmit');
    onSubmit(report, function () {
      return isLoadingCallback(_onClose);
    });
  };

  return /*#__PURE__*/_react.default.createElement(_BrandOverlay.default, {
    open: true,
    contentStyle: {
      paddingBlock: 0
    },
    title: t('feedback_report_title'),
    onClose: function onClose() {
      return _onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(StyledDialogContent, {
    dividers: true,
    sx: {
      borderTop: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(_BrandSelect.default, {
    options: formTypes,
    value: selectedForm,
    placeholder: t('feedback_report_type_select'),
    onChange: function onChange(v) {
      return setSelectedForm(v);
    },
    sx: {
      width: '250px'
    }
  })), /*#__PURE__*/_react.default.createElement(_context.default, {
    service: service
  }, selectedForm ? /*#__PURE__*/_react.default.createElement(StyledDialogContent, null, /*#__PURE__*/_react.default.createElement(Feedback, {
    userEmail: userEmail,
    locale: locale,
    selectedForm: selectedForm,
    onSubmit: function onSubmit(report, callback) {
      return submitHandler(report, callback);
    }
  })) : /*#__PURE__*/_react.default.createElement(_Background.default, null)));
}

FeedbackForm.propTypes = {
  onClose: _propTypes.default.func,
  userEmail: _propTypes.default.string,
  service: _propTypes.default.string
};
var _default = FeedbackForm;
exports.default = _default;